<template>
  <section class="mt-3" id="chart">
    <b-row>
      <b-col>
        <b-alert variant="warning" :show="showWarning">
          Selezionare almeno un canale per i consumi e un solo parametro di riferimento
        </b-alert>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <apexchart height="400" type="scatter" :options="options" :series="series"></apexchart>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import Vue from 'vue'
import VueApexCharts from 'vue-apexcharts'
import NeedUpdateMixin from "../../NeedUpdateMixin";
Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)

export default {
  name: 'ScatterChart',
  props: ['filter'],

  mixins: [NeedUpdateMixin],

  created() {
    this.reload()
  },

  data() {
    return {

      options: {
        colors: this.$store.state.colors,
        markers: {
          size: 2
        },
        tooltip: {
          enabled: false,
        },
        chart: {
          locales: this.getChartsLocales(),
          defaultLocale: "it",
          animations: {
            enabled: false,
            speed: 200,
            animateGradually: {
                enabled: false
            },
          },
          toolbar: {
              tools: {
                  download: false,
                  selection: true,
                  zoom: true,
                  zoomin: true,
                  zoomout: true,
                  pan: true,
                  reset: true
              }
          },
          legend: {
            show: true
          },
          zoom: {
            type: 'x',
            enabled: true
          }
        },
        xaxis: {
          title: {},
          labels: {
            formatter: (x) => x.toFixed(0)
          }
        },
        yaxis: {
          title: {}
        },
        title: {}
      },
      series: [{
        name: "",
        data: []
      }],
      showWarning: false
    }
  },

  methods: {
    reload() {
      if (this.loading) {
        return;
      }

      this.showWarning = !(this.filter.channels.length > 0 && this.filter.parameters.length == 1)

      if(!this.showWarning) {
        this.$store.commit('loading');

        this.$store.dispatch('charts/get', this.filter).then( (data) => {
          if(data.values.length == 0)
            return

          this.series[0].name = data.columns[2]
          this.series[0].data = data.values.map( v => {
            return [ v[2], v[1] ]
          })

          var options = _.cloneDeep(this.options)

          options.title = {
            text: data.columns[1]
          }
          options.yaxis = {
            title: {
              text: data.columns[1] + " [" + data.mus[0] + "]"
            }
          }
          options.xaxis.title.text = data.columns[2] + " [" + data.mus[1] + "]"
          this.options = options
        })
        .finally(() => {
          this.$store.commit('stopLoading');
        })
      }
    }
  },

  watch: {
    filter() {
      _.debounce(this.reload, 10)();
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Charts/Types/Apex/Scatter.vue